import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Assignments } from '../_models/assignments';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AssignmentsService {

  constructor(
    private http: HttpClient
  ) { }

  getAllAssignments(){
    return this.http.get<Assignments[]>(`${environment.apiUrl}/api/worker_assignments`)
    .pipe(map(responseData =>{
      return responseData;
    })
    )
  }

  updateAssignments(users:{ id:number, assignments:number[] }){
    return this.http.patch(`${environment.apiUrl}/api/worker_assignments`,users);
  }
}
